import React, { useState } from "react";
import {
  Stack,
  InputLabel,
  OutlinedInput,
  FormHelperText,
  InputAdornment,
  Typography,
  useTheme,
  IconButton,
  MenuItem,
  Select,
} from "@mui/material";
// import { FormattedMessage } from "react-intl";
// import { ThemeContext } from "@emotion/react";
import { ReactTransliterate } from "react-transliterate";
import "react-transliterate/dist/index.css";
import { transliterateLanguages } from "../constants/SelectionOptions";

const CustomTransliterateTextField = ({
  id,
  value,
  label,
  name,
  onChange,
  onChangeText,
  sx,
  isError,
  error,
  onBlur,
  icon,
  onClick,
  onMouse,
  position,
  color,
  disabled,
  placeholder,
  rows,
  multiline,
  inputProps,
  endAdornment,
  fullWidth = true,
  required,
  onKeyDown,
  textAlign = "left",
  autoCapitalize = false,
  max,
  min,
  startAdornment,
}) => {
  const theme = useTheme();

  const [lng, setLng] = useState("en");
  const trimmedValue = typeof value === "string" ? value.trimStart() : value;

  return (
    <Stack spacing={0.5} width="100%">
      {label && (
        <InputLabel
          htmlFor={id}
          required={required}
          style={{
            visibility: label === "no-label" && "hidden",
            fontWeight: 700,
            fontSize: 12,
            color: required
              ? theme.palette.secondary.main
              : theme.palette.grey[700],
          }}
        >
          {/* <FormattedMessage id={label} /> */}
          {label}
        </InputLabel>
      )}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="stretch"
        spacing={1}
      >
        {lng === "en" ? (
          <OutlinedInput
            id={id}
            type="text"
            value={trimmedValue}
            name={name}
            size="small"
            onChange={(e) => {
              onChangeText(e.target.value);
            }}
            fullWidth={fullWidth}
            error={isError}
            disabled={disabled ? disabled : false}
            startAdornment={startAdornment}
            endAdornment={endAdornment}
            multiline={multiline}
            rows={rows}
          />
        ) : (
          <ReactTransliterate
            renderComponent={(props) => {
              const inputRef = props.ref;
              delete props["ref"];
              return (
                <OutlinedInput
                  id={id}
                  name={name}
                  error={isError}
                  fullWidth
                  size="small"
                  {...props}
                  inputRef={inputRef}
                  startAdornment={startAdornment}
                  endAdornment={endAdornment}
                />
              );
            }}
            disabled={disabled ? disabled : false}
            maxOptions={5}
            activeItemStyles={{
              backgroundColor: theme.palette.primary.main,
            }}
            containerStyles={{ width: "100%" }}
            value={trimmedValue}
            onChangeText={onChangeText}
            lang={lng}
            multiline={multiline}
            rows={rows}
          />
        )}
        <Select
          size="small"
          sx={{ minWidth: 100 }}
          value={lng}
          onChange={(e) => {
            setLng(e.target.value);
          }}
        >
          {Array.isArray(transliterateLanguages) &&
            transliterateLanguages.map((option, index) => {
              return (
                <MenuItem key={index} value={option.id}>
                  {option.title}
                </MenuItem>
              );
            })}
        </Select>
      </Stack>
      {isError && (
        <FormHelperText error id={`standard-weight-helper-text-${id}`}>
          {error}
        </FormHelperText>
      )}
    </Stack>
  );
};

export default CustomTransliterateTextField;
